import WaitingForPair from './WaitingForPair'

export default WaitingForPair
